import { Box, Typography } from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import aiStarAnimated from "assets/images/ai-star-animated.gif";

interface AiLoadingProps {
  isLoading: boolean;
}

const AiLoading: FC<AiLoadingProps> = ({ isLoading }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [animationStep, setAnimationStep] = useState(0);

  const loadingMessages = [
    "Analyzing route data...",
    "Optimizing your routes. This may take a moment...",
    "Finding the most efficient routes...",
    "AI is calculating the best route – almost there...",
  ];

  useEffect(() => {
    if (!isLoading) return;

    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 5000);

    const dotInterval = setInterval(() => {
      setAnimationStep((prev) => prev + 1);
    }, 500);

    return () => {
      clearInterval(messageInterval);
      clearInterval(dotInterval);
    };
  }, [isLoading, loadingMessages.length]);

  return (
    <Box p={4}>
      <div
        style={{
          position: "relative",
          textAlign: "center",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "24px",
            position: "relative",
          }}
        >
          <img
            src={aiStarAnimated}
            alt="AI Processing"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>

        <Typography variant="h6">
          {loadingMessages[currentMessageIndex]}
        </Typography>

        <div
          style={{
            display: "flex",
            gap: "4px",
            marginTop: "8px",
          }}
        >
          {[0, 1, 2].map((dot) => (
            <div
              key={dot}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#2B3674",
                opacity: dot === animationStep % 3 ? 1 : 0.3,
                transition: "opacity 0.3s ease-in-out",
              }}
            />
          ))}
        </div>
      </div>
    </Box>
  );
};

export default AiLoading;
